import ReceiptTax from 'components/receipt/commons/CountingBox/ReceiptTax'
import Subtotal from 'components/receipt/commons/CountingBox/Subtotal'
import Gratuity from 'components/receipt/commons/CountingBox/Gratuity'
import styles from './CountingBox.css'
class CountingBox extends React.Component {
  render () {
    let {paymentDetail} = this.props
    // noinspection JSUnresolvedVariable
    return (<div className={styles['counting-box']}>
      <Subtotal subtotal={paymentDetail.subtotal} />
      {paymentDetail.enable_gratuity && <Gratuity gratuities={paymentDetail.payment_gratuities}
        includeGratuityTax={paymentDetail.include_gratuity_tax} />}

      {paymentDetail.enable_tax && <ReceiptTax taxes={paymentDetail.payment_taxes}
        includeGratuityTax={paymentDetail.include_gratuity_tax} />}
    </div>)
  }
}

CountingBox.propTypes = {
  paymentDetail: React.PropTypes.object
}

export default CountingBox



// WEBPACK FOOTER //
// ./app/components/receipt/transactions/CountingBox/CountingBox.js